import './App.css';
import Home from "./components/Home/Home";
import NavBar from './components/NavBar/NavBar';
function App() {
  return (
    <>
      <NavBar />
      <Home />
    </>
  );
}

export default App;
